import {Component, Input, OnInit} from '@angular/core';
import {Attributo} from '../../../common/model/attributo.model';
import {FormGroup} from '@angular/forms';

@Component({
    selector: 'app-form-layout-attributi',
    template: `
    <div [formGroup]="attributiForm">
      <div *ngFor="let attributo of attributi">

        <app-control-text
          *ngIf="attributo.tipo.isText()"
          formControlName="{{ attributo.nome }}">
        </app-control-text>

        <app-control-colorpicker
          *ngIf="attributo.tipo.isColor()"
          formControlName="{{ attributo.nome }}">
        </app-control-colorpicker>

      </div>
    </div>
     `,
    styles: [],
    standalone: false
})
export class FormTemplateAttributiComponent implements OnInit {

  @Input() attributiForm: FormGroup;

  @Input() attributi: Attributo[];

  public ngOnInit() {
    console.log(this.attributiForm);
  }

}

